import Vue from 'vue';
import { memberBindingSa } from '../../../services/personnelService/bindSaService';
import { memberBindingSaByStore, checkMemberBind } from '../../../services/crmService/bindSaService';
import { getStoreDropdown } from '../../../services/storeMapService/storeService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  saInfo: null,
  storeDropdown: []
};

// getters
const getters = {};

// actions
const actions = {
  // 取得CA Profile
  async memberBindingSaHandler({}, bindingInfo) {
    const data = await memberBindingSa(bindingInfo);
    return data;
  },
  // 取得專門店下拉
  async getStoreDropdownHandler({ commit }, query) {
    const data = await getStoreDropdown(query);
    commit('setStoreDropdown', data.data);
  },
  async memberBindingSaByStoreHandler({}, bindingInfo) {
    const data = await memberBindingSaByStore(bindingInfo);
    return data;
  },
  // 檢查會員是否綁定及是否綁定CA
  async checkMemberBindHandler({}, bindingInfo) {
    const data = await checkMemberBind(bindingInfo);
    return data;
  },
};

// mutations
const mutations = {
  setSaInfo(state, data) {
    Vue.set(state, 'saInfo', data);
  },
  setStoreDropdown(state, data) {
    Vue.set(state, 'storeDropdown', data.data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
